var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"38px"}},[_c('div',{staticClass:"year font-medium transform -rotate-90 text-4xl mt-14 -ml-4 -mr-1",class:{ 'text-muted': !_vm.active, 'text-active': _vm.active }},[_vm._v(_vm._s(_vm.year))])])}
var staticRenderFns = []

export { render, staticRenderFns }